// JWT Token Types
export interface JWTPayload {
  customerId: string;
  exp: number;
  iat?: number;
}

export interface DecodedToken extends JWTPayload {
  isValid: boolean;
  isExpired: boolean;
}

// API Response Types
export interface MagicLinkResponse {
  uploadUrl: string;
}

export interface SignUrlResponse {
  method: 'PUT';
  url: string;
  fields?: Record<string, string>;
}

export interface ApiError {
  message: string;
  statusCode: number;
  details?: unknown;
}

// File Upload Types
export interface UploadFile {
  id: string;
  name: string;
  size: number;
  type: string;
  lastModified: number;
}

export interface UploadProgress {
  fileId: string;
  progress: number;
  bytesUploaded: number;
  bytesTotal: number;
}

export interface UploadResult {
  fileId: string;
  fileName: string;
  success: boolean;
  url?: string;
  error?: string;
}

// Application State Types
export interface AuthState {
  token: string | null;
  customerId: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface AppConfig {
  apiBaseUrl: string;
  allowedFileTypes: string[];
  maxFileSize: number;
  environment: 'development' | 'production';
}

// Uppy Configuration Types
export interface UppyConfig {
  restrictions: {
    allowedFileTypes: string[];
    maxFileSize: number;
    maxNumberOfFiles: number | null;
  };
  autoProceed: boolean;
  debug: boolean;
}

// Error Types
export class AuthenticationError extends Error {
  constructor(message: string, public statusCode: number = 401) {
    super(message);
    this.name = 'AuthenticationError';
  }
}

export class UploadError extends Error {
  constructor(message: string, public fileName?: string) {
    super(message);
    this.name = 'UploadError';
  }
}

export class ValidationError extends Error {
  constructor(message: string, public field?: string) {
    super(message);
    this.name = 'ValidationError';
  }
}